(function() {
  function initCarousel(section) {
    var slides = section.querySelectorAll('.hero-slide');
    var dots = section.querySelectorAll('.dot');
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5;
    var currentIndex = 0;
    var intervalId = null;

    if (slides.length === 0 || dots.length === 0) return;

    function goToSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach(function(slide, i) {
        slide.classList.toggle('active', i === currentIndex);
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
      });
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToSlide(i);
        if (autoplay && intervalId) {
          clearInterval(intervalId);
          intervalId = setInterval(nextSlide, speed * 1000);
        }
      });
    });

    if (autoplay && speed > 0) {
      intervalId = setInterval(nextSlide, speed * 1000);
    }
  }

  function init() {
    document.querySelectorAll('.landing-hero-bison.hero-section').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.landing-hero-bison.hero-section');
    if (section) initCarousel(section);
  });
})();
